import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'
import SwitchIllustration from '@/components/landing/switch-illustration'
import TypingSoundPlayer from '@/components/landing/typing-sound-player'

import { SWITCH_SPECS } from '@/constants/specs'

const SwitchSection: FC = (): ReactNode => {
    return (
        <section id='switches' className='relative px-6 py-24 sm:py-36'>
            <div className='mx-auto grid max-w-[960px] items-center gap-12 md:grid-cols-2 md:gap-16'>
                <div className='relative flex justify-center'>
                    <div
                        aria-hidden='true'
                        className='pointer-events-none absolute inset-y-[-12%] left-1/2 w-[240px] -translate-x-1/2 rounded-full bg-[radial-gradient(closest-side,rgb(255_255_255/0.055),rgb(255_255_255/0.015)_60%,transparent)]'
                    />

                    <SwitchIllustration className='relative w-[180px] sm:w-[210px]' />
                </div>

                <Reveal>
                    <h2 className='text-[28px] leading-[1.2] font-medium tracking-[-0.025em] text-white sm:text-[30px]'>
                        Mechanical feel.
                        {' '}
                        <span className='text-[#76777b]'>
                            Quiet by design.
                        </span>
                    </h2>

                    <p className='mt-4 max-w-[440px] text-[15px] leading-[1.65] text-[#8e8f93]'>
                        Nano Blush linear switches deliver a smooth, satisfying typing experience with a sound made for shared spaces.
                    </p>

                    <div className='mt-8 grid gap-x-10 sm:grid-cols-2'>
                        {SWITCH_SPECS.map((column, index) => (
                            <dl key={index}>
                                {column.map(spec => (
                                    <div
                                        key={spec.label}
                                        className='flex items-center justify-between gap-4 border-b border-white/10 py-[11px] font-mono text-[11.5px] tracking-[0.1em] uppercase'
                                    >
                                        <dt className='text-[#77787c]'>
                                            {spec.label}
                                        </dt>

                                        <dd className='text-right font-medium text-white'>
                                            {spec.value}
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                        ))}
                    </div>

                    <TypingSoundPlayer className='mt-10' />
                </Reveal>
            </div>
        </section>
    )
}

export default SwitchSection
